import {gql, useQuery} from '@apollo/client';
import {useAccountContext} from '../contexts/AccountContext';
import {HardFacts, HardFactsVariables} from '../schema-types/HardFacts';
import validateUUID from '../utils/validateUUID';

export const HARD_FACTS = gql`
  query HardFacts($accountId: UUID!, $curoSync: Boolean) {
    hardFacts(accountId: $accountId, curoSync: $curoSync) {
      id
      incomes {
        id
        account {
          id
        }
        contact {
          id
          simplifiedName
        }
        owner {
          id
          name
        }
        incomeDescription
        incomeAmount
        endDate
        gross
        incomeType
        incomeSource
        incomeFrequency
        status
        currentStatus
        taxable
      }
      expenditures {
        id
        account {
          id
        }
        contact {
          id
          simplifiedName
        }
        owner {
          id
          name
        }
        expenseDescription
        expenseAmount
        expenseFrequency
        endDate
      }
      gifts {
        id
        giftValue
        typeOfGift
        dateOfGift
        contact {
          id
          simplifiedName
        }
        recipientName
        currentStatus
      }
      liabilities
      liabilitiesFacts {
        id
        currentDebt
        repaymentAmount
        category
        frequency
        asAtDate
        contact {
          id
          simplifiedName
        }
        product {
          id
          name
          reportName
        }
        provider {
          id
          name
          reportName
        }
      }
      assets {
        id
        value
        name
        ownership
        category
        valuationDate
        contact {
          id
          simplifiedName
        }
      }
    }
  }
`;

export const useHardFacts = () => {
  const {accountId} = useAccountContext();
  const {data, error, loading} = useQuery<HardFacts, HardFactsVariables>(HARD_FACTS, {
    variables: {
      accountId: validateUUID(accountId)!,
    },
    skip: !validateUUID(accountId),
  });
  return {data, error, loading};
};
